<template>
    <div class="lp_Title" :class="{ border:isShowBorder }">
      <div class="title">{{ title }}</div>
      <div class="more" v-if="isShowMore" @click="moreClick">
        <span>更多</span>
        <img src="../../assets/images/more.png" alt="">
      </div>
    </div>
</template>

<script>
  export default {
    name: "lp_Title",
    props:{
      title:{//标题
        type:String,
        default:'标题'
      },
      //是否展示下划线
      isShowBorder:{
        type:Boolean,
        default:true
      },
      //是否展示更多
      isShowMore:{
        type:Boolean,
        default:true
      },
      //查看更多跳转地址
      moreHref:{
        type:String,
        default:''
      },
    },
    data () {
      return{

      }
    },
    methods: {
      //查看更多
      moreClick(){
        this.$router.push({path:this.moreHref});
      }
    },
  }
</script>

<style scoped lang="less">
.lp_Title{
  width: 100%;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 20px;
    color: #333333;
    font-weight: bold;
  }
  .more{
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHeiUI;
    font-size: 14px;
    color: #333333;
    cursor: pointer;
    img{
      width:14px;
      height: 14px;
      vertical-align: middle;
      margin-left: 6px;
    }
    span:hover{
      color:@hoverDefaultColor;
    }
  } 
}
.border{
  border-bottom: 1px solid #1582F3;
}
</style>


// WEBPACK FOOTER //
// src/components/title/index.vue